import cn from "classnames";
import { gql } from "graphql-request";
import styled from "styled-components";
import { Markdown } from "components";
import { ComponentNestedTabelSaversElement } from "types/graphql/generated";
import { TableRow } from "./TableRow";

interface Props {
  className?: string;
  content: ComponentNestedTabelSaversElement;
}

const TableBodyRow = ({ content: { title, valueSup, valueOne, valueSupTwo, valueTwo }, className = "" }: Props) => {
  return (
    <StyledTableBodyRow className={cn(className, {})}>
      <TableRow>
        <div className="CellName">
          <Markdown className="Font_24_32_600 lg:Font_16_22_600 md:Font_14_20_600">{title}</Markdown>
        </div>
        <div className="CellValueOne">
          <Markdown className="Font_24_32_600 lg:Font_16_22_600 md:Font_14_20_600">{valueOne}</Markdown>
          {valueSup && (
            <Markdown className="CellSupValue Color_dusk50 Font_16_22_600 md:Font_12_16_600">{valueSup}</Markdown>
          )}
        </div>
        <div className="CellValueTwo">
          <Markdown className="Font_24_32_600 lg:Font_16_22_600 md:Font_14_20_600">{valueTwo}</Markdown>
          {valueSupTwo && (
            <Markdown className="CellSupValue Color_dusk50 Font_16_22_600 md:Font_12_16_600">{valueSupTwo}</Markdown>
          )}
        </div>
      </TableRow>
    </StyledTableBodyRow>
  );
};

const StyledTableBodyRow = styled.li`
  padding: 20px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.fog["30"]};

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    padding: 12px 0;
  }
`;

gql`
  fragment TableSaversBodyRowFragment on ComponentNestedTabelSaversElement {
    id
    title
    valueOne
    valueTwo
    valueSup
    valueSupTwo
  }
`;

export { TableBodyRow };
